var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-sms-modal-keyboard sms-modal-keyboard"},_vm._l((_vm.keyboardKeys),function(button,index){return _c('AKeyboardKey',{key:index,attrs:{"item":button},on:{"onClick":_vm.onClick}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }